import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {MainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuView';
import {MainMenuModule} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuModule';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';

export class MainMenuBasicState extends ModuleState<MainMenuView, MainMenuModule> {
	public onEnterState(): void {
		this.emit(MainMenuEvents.MAIN_MENU_CLOSED);
		(this.view as MainMenuView).hideMainMenu();
		//
	}

	public onLeaveState(): void {
		//
	}

	protected setupEvents(): void {
		//
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/states/MainMenuBasicState.ts